var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.95996 18.0918C5.54168 18.0918 1.95996 14.5101 1.95996 10.0918C1.95996 5.67352 5.54168 2.0918 9.95996 2.0918C14.3782 2.0918 17.96 5.67352 17.96 10.0918C17.96 14.5101 14.3782 18.0918 9.95996 18.0918ZM10.4481 6.90247L12.8424 9.34686C13.5158 10.0222 12.5056 11.0355 11.832 10.3601L11.0124 9.53505C10.8258 9.34721 10.6745 9.40948 10.6745 9.67421V12.9592C10.6745 13.3518 10.3546 13.6739 9.96006 13.6739C9.56632 13.6739 9.24568 13.3539 9.24568 12.9592V9.67421C9.24568 9.41091 9.09436 9.34718 8.90769 9.53505L8.08791 10.3601C7.41449 11.0355 6.40411 10.0222 7.07754 9.34686L9.44725 6.90585C9.72431 6.62045 10.1714 6.61998 10.4481 6.90247ZM9.95996 16.4202C13.455 16.4202 16.2883 13.5869 16.2883 10.0918C16.2883 6.59674 13.455 3.76344 9.95996 3.76344C6.46491 3.76344 3.6316 6.59674 3.6316 10.0918C3.6316 13.5869 6.46491 16.4202 9.95996 16.4202Z",
    fill: "#A50808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.14ba71587ee61b4bb44a89e077771826.svg";
export { ForwardRef as ReactComponent };